export default {
    download(response) {

        const content = new Blob([response.data], {type: response.headers['content-type']})
        const url = URL.createObjectURL(content)
        const link = document.createElement('a')

        link.href = url
        link.target = '_blank'
        link.click()
        link.remove()
    }
}